import React from 'react';

import { Form, FormInstance } from '@ui-library/form';
import { FormConfig, FieldProps, FieldConfigMap } from '@api';

import { TextField, SelectField, SwitchField, TextAreaField, SecretTextField } from './components';

interface LightFormBuilderProps {
  formConfig: FormConfig;
  form: FormInstance;
  variant?: 'next';
}

const fieldComponentMap = {
  textField: TextField,
  textAreaField: TextAreaField,
  selectField: SelectField,
  switchField: SwitchField,
} as const;

const resolveFieldComponent = (fieldConfig: FieldConfigMap[keyof FieldConfigMap]) => {
  if (fieldConfig.component === 'textField' && fieldConfig.secret) {
    return SecretTextField;
  }
  return fieldComponentMap[fieldConfig.component];
};

export const LightFormBuilder: React.FC<LightFormBuilderProps> = ({
  form,
  formConfig,
  variant,
}) => (
  <Form variant={variant} form={form} size="large" layout="vertical">
    {formConfig.fields.map((fieldConfig) => {
      const FieldComponent = resolveFieldComponent(fieldConfig) as React.FC<
        FieldProps<keyof FieldConfigMap>
      >;

      return FieldComponent ? (
        <FieldComponent
          key={Array.isArray(fieldConfig.key) ? fieldConfig.key.join('.') : fieldConfig.key}
          fieldConfig={fieldConfig}
        />
      ) : null;
    })}
  </Form>
);
